export const CAMPSITE_EXTRAS = "CAMPSITE_EXTRAS"

export const FETCH_CAMPSITE_EXTRAS = "FETCH_CAMPSITE_EXTRAS"

export const SELECTED_CAMPSITE_EXTRAS = "SELECTED_CAMPSITE_EXTRAS"

export const UPDATE_CAMPSITE_EXTRAS = "UPDATE_CAMPSITE_EXTRAS"

export const CLEAR_CAMPSITE_EXTRAS_RECORDS = "CLEAR_CAMPSITE_EXTRAS_RECORDS"
